import TELabel from './TELabel';

export default TELabel;
